<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BhbLo3/images/MyCoverImage.jpg?1733151179105" alt="This image is the cover for the book Jean-Paul Sartre: To Freedom Condemned"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jean-Paul Sartre: To Freedom Condemned
      </h1>
      <p class="bookDescription body article font2">
        <p>J<b>ean-Paul Sartre’s most influential existentialist work, <i>Being and Nothingness</i></b><b>, broken down into its most fertile ideas <br/></b>In <i>To Freedom Condemned</i>, Sartre’s most influential work, <i>Being and Nothingness</i>, is laid bare, presenting the philosopher’s key ideas regarding existentialism. Covering the philosophers Hegel, Heidegger, and Husserl, and mulling over such topics as love, God, death, and freedom, <i>To Freedom Condemned</i> goes on to consider Sartre’s treatment of the complexities around human existence.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Justus Streller, Wade Baskin
      </h2>
      
      <p class="authorDescription body article">Justus Streller is the author of <I>Jean-Paul Sartre: To Freedom Condemned</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f4169c50